import { isInLoginGracePeriod } from './loginGrace';

/** Registered by AuthProvider — clears UI session when access/refresh credentials are dead. */
type SessionExpiredHandler = () => void;

let handler: SessionExpiredHandler | null = null;
let notifyPending = false;

export function registerSessionExpiredHandler(fn: SessionExpiredHandler | null): void {
  handler = fn;
}

export function resetSessionExpiredNotifyGate(): void {
  notifyPending = false;
}

/**
 * Log out the UI session once per expiry episode (avoids duplicate logouts from parallel API calls).
 * Runs async so token resolution can finish before Auth state updates.
 */
export function notifySessionExpired(): void {
  if (isInLoginGracePeriod()) {
    return;
  }
  if (notifyPending || !handler) {
    return;
  }
  notifyPending = true;
  queueMicrotask(() => {
    handler?.();
  });
}
